import React                          from 'react';
import { Observe }                         from 'rewire-core';
import { WithStyle, withStyles }           from 'rewire-ui';
import Typography                          from '@material-ui/core/Typography';
import { Theme }                           from '@material-ui/core/styles';
import Grid                                from '../ui/Grid';
import timecardTestSummaryDailyRollupModel from './TimecardTestSummaryDailyRollupModel';
import { defaultFontSizes }                from '../timecard/TimecardGrids';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '8px',
  },
  titleContainer: {
    display: 'flex',
    marginBottom: '10px',
  },
  title: {
    marginRight: '15px',
  },
  grid: {
    '& tbody tr:hover': {
      backgroundColor: '#e0e9f0',
    },
    '& tr th div': {
      color: 'white',
      fontStyle: 'normal',
    },
    '& td.readOnly': {
     color: '#4f778a',
    },
    '& td.future': {
      fontStyle: 'italic',
      color: theme.palette.text.disabled,
    },
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
  },
});

interface ITimecardTestSummaryDailyRollupProps {
}

type TimecardTestSummaryDailyRollupProps = WithStyle<ReturnType<typeof styles>, ITimecardTestSummaryDailyRollupProps>;

class TimecardTestSummaryDailyRollupView extends React.PureComponent<TimecardTestSummaryDailyRollupProps> {
  constructor(props: TimecardTestSummaryDailyRollupProps) {
    super(props);
  }

  componentWillUnmount() {
    timecardTestSummaryDailyRollupModel.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.titleContainer}>
          <Typography variant='h6' className={classes.title}>Timecard Summary</Typography>
        </div>
        <Observe render={() => (
          <Grid key={timecardTestSummaryDailyRollupModel.grid.id} grid={timecardTestSummaryDailyRollupModel.grid} gridFontSizes={defaultFontSizes} className={classes.grid} />
        )} />
      </div>
    );
  }
}

export default withStyles<ITimecardTestSummaryDailyRollupProps,unknown>(styles, TimecardTestSummaryDailyRollupView);
